import React from 'react';
import { useTranslation } from 'react-i18next';
import Accordion from '../Accordion/Accordion';
import classes from './FAQ.module.css';

const groups = [
  { key: 'general', questions: [1, 2, 3] },
  { key: 'sessions', questions: [4, 5, 6, 12, 7, 8, 9, 10] },
  { key: 'payments', questions: [11, 13] },
];

const FAQ: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="faq" className={classes.faq}>
      <h2>{t('FAQs.headline')}</h2>
      <div className={classes.list}>
        {groups.map((group) => (
          <div key={group.key}>
            <h3 className={classes.groupTitle}>
              {t(`FAQs.groups.${group.key}`)}
            </h3>
            {group.questions.map((n) => (
              <Accordion
                key={n}
                question={t(`FAQs.questions.q${n}`)}
                answer={t(`FAQs.questions.a${n}`)}
              />
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
